import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { frameworkStages } from '../data/framework';
export function MasterMap() {
  return <section className="w-full bg-brand-dark px-4 py-16 sm:py-24" data-id="element-235" data-mp="3ulnijhs5j2ty">
      <div className="mx-auto max-w-6xl" data-id="element-236" data-mp="3ujubw2hjgily">
        <SectionHeading tone="dark" eyebrow="The Framework" title="The Perio Blueprint™ Master Clinical Map" intro="One visual framework. Six connected stages. A clearer way to organize your periodontal case review." data-id="element-237" data-mp="3pnm2z6txpln8" />

        <ol className="relative mx-auto mt-12 grid max-w-xl gap-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-6 lg:gap-y-10" data-id="element-238" data-mp="3bn1js9k3xnt7">
          {frameworkStages.map((stage, i) => <li key={stage.title} className="relative flex gap-4 pb-8 lg:flex-col lg:pb-0" data-id="element-239" data-mp="36psza2bhl7os" data-mpi={i}>
              {i < frameworkStages.length - 1 && <span className="absolute left-[23px] top-12 h-[calc(100%-48px)] w-0.5 bg-white/15 lg:hidden" aria-hidden="true" data-id="element-240" data-mp="14wv4i0y5g517" />}
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold font-serif text-2xl font-black text-brand-dark" data-id="element-241" data-mp="lhmgmvlh2731">
                {i + 1}
              </span>
              <div className="pt-1 lg:pt-0" data-id="element-242" data-mp="cgeg06vhgu5s">
                <h3 className="font-sans text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-243" data-mp="chg3xbxllb4x">{stage.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-white/75" data-id="element-244" data-mp="1094sch7atfgl">{stage.text}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-sm italic leading-relaxed text-white/60" data-id="element-245" data-mp="qg610rkf3ata">
          A visual framework for organizing periodontal knowledge—not a substitute for clinical judgment, professional
          training, current scientific evidence, or patient-specific evaluation.
        </p>

        <div className="mt-10" data-id="element-246" data-mp="1nxnyaq2vlg5i">
          <CTAButton label="I Want the Perio Blueprint™" tone="dark" data-id="element-247" data-mp="1xsbmb87sa6mx" />
        </div>
      </div>
    </section>;
}